export default "__VITE_ASSET__DNhyMNee__"